
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 7.04c.62 0 1.107-.045 1.46-.134.36-.093.655-.25.884-.468.229-.224.396-.5.5-.829.104-.333.156-.747.156-1.242 0-.573-.078-1.028-.234-1.367-.157-.344-.355-.596-.594-.758a2.213 2.213 0 00-.86-.351c-.338-.073-.807-.11-1.406-.11H.164V.742h5.297c1.099 0 1.927.13 2.484.39.563.261 1.01.647 1.344 1.157.333.505.5 1.227.5 2.164 0 .386-.036.745-.11 1.078a3.295 3.295 0 01-.335.907c-.146.27-.344.52-.594.75-.245.229-.505.406-.781.53-.276.12-.607.212-.992.274a9.763 9.763 0 01-1.407.086H.164V7.04H5.5z","fill":"currentColor"}})])
          )
        }
      }
    